import { AbstractControl, AsyncValidatorFn, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AuthService } from '@noovle/core';
import { Observable, catchError, map, of, take } from 'rxjs';
import { operationOpts } from './constants';

export const concatObjects = (...args: { [key: string]: any }[]) => {
  const obj = args.reduce((acc, a) => ({ ...a, ...acc }), {});
  Object.keys(obj).forEach(
    (key) => (obj[key] === undefined || obj[key] === null || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) && delete obj[key]
  );

  return obj;
};

export const patternValidator = (regex: RegExp, error: ValidationErrors): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | ValidationErrors | null => {
    const { value = null } = control;
    if (!value) {
      return null;
    }
    const valid = regex.test(value);
    return valid ? null : error;
  };
};

export const validatePassword = (authService: AuthService): AsyncValidatorFn => {
  return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const { value: oldPassword = null } = control || {};
    if (!oldPassword) {
      return of({ required: true });
    }
    return authService.validatePasswordWithLogin(oldPassword).pipe(
      take(1),
      map((res: any) => {
        return res.user ? null : { wrongPassword: true };
      }),
      catchError((err: any) => {
        return of({ wrongPassword: true });
      })
    );
  };
};

export const passwordMatchValidator = (formGroup: FormGroup) => {
  const { value: newpassword } = formGroup.get('newpassword') || {};
  const { value: confirmPassword } = formGroup.get('confirmpassword') || {};
  return newpassword === confirmPassword ? null : { passwordNotMatch: true };
};

export const getUniqueElemsByKey = (arr: any, key: string) => {
  return [...new Map(arr.map((item: any) => [item[key], item])).values()];
};

export const getNeedGroupBy = (query: string) => {
  const regexValue = new RegExp(`${operationOpts.map((opt: any) => opt.label).join('\\s*\\(|')}\\s*\\(`, 'i');
  return regexValue.test(query);
};

export const compareObjects = (property: string) => {
  return (el1: any, el2: any) => (el2?.[property] ? el1?.[property] === el2?.[property] : el1 === el2);
};
